module.exports = __webpack_public_path__ + "static/img/scene03.66766ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scene03.png
// module id = /5L0
// module chunks = 1